// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"d9d99bbb","51":"1329f437","78":"d9d99bbb","826":"d9d99bbb","850":"a3333c56"}[chunkId] + ".chunk.css";
};